<template>
	<div>
		<el-card header="投保人员">
			<div v-if="getFormConfig.label" slot="header">
				<span v-html="clearPLabel(getFormConfig.label)"></span>
			</div>
			<template>
				<el-alert
					v-if="isShowAlert"
					:title="isShowAlert"
					show-icon
					style="margin-bottom: 10px"
					type="warning"></el-alert>
				<el-row>
					<avue-crud
						ref="refEmp"
						:class="isEmployeeSubmit ? 'emp_submitted' : ''"
						:data="getOnPageItemData"
						:option="optionEmployee"
						:page.sync="empPage"
						:table-loading="employeeLoading"
						@current-row-change="onCurrentRowChange"
						@cell-click="onCellClick">
						<template slot="professionIdHeader" slot-scope="{column}">
							{{ column.label }}
							<el-button v-if="!isEmployeeSubmit" style="margin-left: 5px" type="text" @click="onClearProfession()">
								清空
							</el-button>
						</template>
						<template #menuRight="{}">
							<div class="u-flex">
								<el-button :loading="isDownLoading" icon="el-icon-circle-close" @click="onClearAllData">
									一键清空
								</el-button>
								<el-button :loading="isDownLoading" icon="el-icon-download" @click="handleGetEmployeeTemplate">
									模版
								</el-button>
								<el-upload
									:auto-upload="false"
									:on-change="handleEmployeeFileChange"
									:show-file-list="false"
									accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
									action="">
									<el-button class="el-icon-upload2" type="primary">批量上传</el-button>
								</el-upload>
							</div>
						</template>

						<template #menuLeft="{}">
							<div class="u-flex">
								<el-button :loading="isDownLoading" icon="el-icon-plus" type="primary" @click="onAddEmp(false)">
									新增
								</el-button>
								<el-button
									:loading="isDownLoading"
									icon="el-icon-plus"
									type="primary"
									@click="$refs.refCardDialog.show()">
									身份证批量上传
								</el-button>
							</div>
						</template>
						<template #menu="{index}">
							<div class="u-flex u-row-center">
								<el-button :loading="isDownLoading" icon="el-icon-circle-close" type="text" @click="onDelEmp(index)">
									删除
								</el-button>
							</div>
						</template>
					</avue-crud>
				</el-row>
				<el-row justify="end" type="flex">
					<div class="u-m-t-10 u-font-16 u-font-weight-bold">
						保费合计：
						<span class="red-bold">{{ totalPrice }}</span>
						元
					</div>
				</el-row>
				<el-row justify="center" type="flex">
					<el-button
						v-if="!isEmployeeSubmit"
						:loading="employeeLoading"
						icon="el-icon-check"
						type="primary"
						@click="onSubmitEmployee()">
						确认
					</el-button>
					<el-button v-else icon="el-icon-edit" @click="onCheckEmpResult(false)">修改</el-button>
				</el-row>
			</template>
		</el-card>
		<card-dialog ref="refCardDialog" @onCardSuccess="onCardSuccess"></card-dialog>
		<InsureNotices
			ref="refInsureNoticesHint"
			@onToSureEnd="onConfirmAutoStatus"
			@onToCancel="onToCancel"></InsureNotices>
	</div>
</template>
<script>
import {baseEmployeeOption, getCompleteOption} from 'meibao-insure/src/option/baseOption'
import {
	checkIdNo,
	fetchEmployeeListPage,
	getProfessionCategory,
	getProfessionTreeWithQuery,
} from '@/views/insuranceCenter/api/insureApiNew'
import {isIdCardNoValid} from 'meibao-insure/src/util/validateRules'
import _ from 'lodash'
import {getTransEmpData} from 'meibao-insure/src/util/unitFormUtils'
import {clearEmptyData, clearPLabel, getAgeByCardNo, getPageId} from 'meibao-insure/src/util/commonUtils'
import {currentYYYYmmdd} from 'meibao-insure/src/util/dateUtil'
import {handleDownCategoryFile} from 'meibao-insure/src/api/productCenterNew'
import {getProfessionHistory} from '@/views/insuranceCenter/api/productNew'
import {mapGetters} from 'vuex'
import {isAnZeProduct, isRenBao} from 'meibao-insure/src/util/productUtil'
import CardDialog from '@/components/insurance/cardDialog.vue'
import {onGetInsureAbleOne} from '@/util/paramsUtils'
import {isBxMeidiGuangfu} from '@/config/env'
import InsureNotices from 'meibao-insure/src/components/InsureNotices.vue'
import {setAreaList, isAreaExist} from '@/util/areaUtils'

export default {
	name: 'formEmployeeNew',
	components: {CardDialog, InsureNotices},
	data() {
		return {
			empPage: {
				currentPage: 1,
				pageSize: 10,
				total: 0,
				pageSizes: [10, 20],
			},
			employeeLoading: true,
			isDownLoading: false,
			optionEmployee: {},
			dataEmployeeList: [],
			dataEmployeeItem: [],
			//工种
			professionAllData: [],
			isEmployeeSubmit: false,
			choiceProfessionData: new Map(),
			//取消后不触发数据
			isCancelNoPrice: true,
			//涉高key
			highKey: '',
			//工种
			professionKey: '',
			isCategoryError: '',
			//批量录单
			isSameEmp: true,
			//存储二要素校验通过的数据
			checkYesResult: [],
			//当前保单数据
			currentProfessionMap: new Map(),
			//原保单人员数据
			oldEmpList: new Map(),
			//是否最低投保人数为1
			isAbleMinOne: false,
			//是否需要计算保费的参数
			needCalcPriceList: new Map(),
			//是否只有一个工种
			singleCategoryId: '',
			//是否继续弹窗的标识
			isContinueProfessionId: '',
		}
	},
	props: {
		actType: String,
		orderId: String,
		totalPrice: String | Number,
		productId: String | Number,
		insureType: String | Number,
		sourceProductId: String | Number,
		isMore: Boolean,
		empFormAllData: {
			type: Object,
			required: true,
			default: () => {
				return {}
			},
		},
		unitFormAllData: {
			type: Object,
			required: true,
			default: () => {
				return {}
			},
		},
		onConfirmAllData: {
			type: Function,
			required: true,
		},
	},
	watch: {
		//@ApiModelProperty("是否允许缺失人员信息报价（1=是；2=否）")
		//private Integer deficiencyOfferFlag = 1;
		empFormAllData: {
			async handler(newVal, odlVal) {
				if (!this.validatenull(newVal)) {
					//处理员工数据！！！
					if (this.isMore) {
						//被保人信息排序加大！orderNum
						for (let newValKey in newVal) {
							let {key = '', orderNum = ''} = newVal[newValKey]
							if (key) {
								newVal[newValKey].orderNum = orderNum + 100
							}
						}
						let {config, ...otherData} = this.unitFormAllData
						Object.assign(newVal, otherData)
					}
					this.optionEmployee = getCompleteOption(newVal, baseEmployeeOption(newVal))
					//批量：处理显隐
					this.onShowBeiEmpData()

					//处理如果是1个人，则去除menu
					this.onDealMaxOne()
					//判断是否有涉高，工种
					this.onHasHigh(newVal)
					try {
						//获取是否允许一人投保
						this.isAbleMinOne = (await onGetInsureAbleOne('INSURE_ABLE_ONE', this.insureType)) || false
					} catch (e) {
						console.error('isAbleMinOne------', e)
					}
					//有工种数据！获取工种数据了
					if (this.professionKey) {
						await this.onGetProfessionData()
					} else {
						//直接添加人
						this.onAddEmp()
					}
				}
			},
			immediate: true,
		},
		'dataEmployeeList.length': {
			handler(newVal, oldVal) {
				this.empPage.total = newVal
				// //处理分页
				// this.onDealOnePageData()
				//修改数据，则需要重新计算保费
				this.$emit('onNeedCalcPrice', false)
			},
		},
		'empPage.currentPage': {
			handler(newVal) {
				this.onShowLoading()
				this.isCancelNoPrice = false
			},
		},
		'empPage.pageSize': {
			handler(newVal) {
				this.onShowLoading()
				this.isCancelNoPrice = false
			},
		},
	},
	computed: {
		...mapGetters(['userInfo']),
		isAdd() {
			return this.actType === 'add'
		},
		/**
		 *  deficiencyOfferFlag ("是否允许缺失人员信息报价（1=是；2=否）")
		 */
		getFormConfig() {
			if (this.validatenull(this.empFormAllData.config)) {
				return {}
			}
			return this.empFormAllData.config
		},
		//获取最少人数
		getMinEmpNum() {
			let {minCountLimit = 1} = this.getFormConfig || {}
			return this.isAbleMinOne ? 1 : minCountLimit
		},
		getMaxEmpNum() {
			let {maxCountLimit = 1000} = this.getFormConfig || {}
			return maxCountLimit
		},
		getOnPageItemData() {
			let {currentPage, total, pageSize} = this.empPage
			if (this.dataEmployeeList.length <= pageSize) {
				return this.dataEmployeeList
			} else {
				return this.dataEmployeeList.slice((currentPage - 1) * pageSize, (currentPage - 1) * pageSize + pageSize)
			}
		},
		//姓名校验
		getVerifiesName() {
			let {verifies = []} = this.empFormAllData.empName || {}
			let {value = ''} = verifies.find(({matchType}) => matchType === 2) || {}
			return value
		},
		//身份证校验
		getVerifiesIdNo() {
			let minAge = 0
			let maxAge = 0
			let {verifies = []} = this.empFormAllData.empIdNo || {}
			//获取最大值和最小值
			for (let verify of verifies) {
				let {matchType, value = ''} = verify || {}
				if (value !== '') {
					if (matchType === 22) {
						minAge = parseInt(value)
					} else if (matchType === 21) {
						maxAge = parseInt(value)
					}
				}
			}
			return {minAge, maxAge}
		},
		isShowAlert() {
			let {notice = {}} = this.getFormConfig || {}
			return notice.content || ''
		},
	},
	async created() {
		//指定延迟开始前调用
		this.onChoiceProfession = _.debounce(this.onChoiceProfession, 500, {leading: true, trailing: false})
		this.onChoiceHigh = _.debounce(this.onChoiceHigh, 500, {leading: true, trailing: false})
	},
	mounted() {
		if (isRenBao(this.insureType)) {
			this.$Bus.$on('onEmitEmpData', this.onEmitEmpData)
		}
	},
	activated() {
		if (isRenBao(this.insureType)) {
			this.$Bus.$on('onEmitEmpData', this.onEmitEmpData)
		}
	},
	deactivated() {
		if (isRenBao(this.insureType)) {
			this.$Bus.$off('onEmitEmpData')
		}
	},
	methods: {
		clearPLabel,
		//获取工种数据
		async onGetProfessionData() {
			//获取当前产品的三级职业分类
			try {
				this.employeeLoading = true
				if (this.isAdd) {
					if (this.validatenull(this.orderId)) {
						this.$message.error('订单号有误！')
						return
					}
					let responseData = await Promise.all([
						getProfessionCategory(this.sourceProductId, this.orderId),
						getProfessionHistory(this.sourceProductId, {orderId: this.orderId}),
					])
					if (this.validatenull(responseData) || responseData.length <= 0) {
						this.$message.error('工种数据有误！')
						return
					}
					let {cates = []} = responseData[0].data.data || {}
					if (cates.length <= 0) {
						throw new Error('工种数据有误！')
					}
					//获取工种数据
					this.professionAllData = this.onGetAllProfessionData(cates)
					// this.professionAllData = responseData[0].data.data || []
					this.professionHistoryList = responseData[1].data.data.hisList || []
					//合并工种
					this.onMergeHistoryProfession()
					//获取原保单人员工种数据信息
					this.getOldEmpList()
				} else {
					let responseData = await getProfessionTreeWithQuery(this.sourceProductId)
					this.professionAllData = responseData.data.data || []
				}
				//处理工种名称
				this.onDealProfessionLevel()
				console.log('this.professionAllData-------', this.professionAllData)
				//赋值给工种
				this.optionEmployee.column.forEach((itemData) => {
					let {type = '', prop = ''} = itemData
					if (type === 'cascader' && prop === 'professionId') {
						itemData.dicData = this.professionAllData
						//选择雇员方法
						itemData.change = this.onChoiceProfession
					} else if (type === 'select') {
						//涉高
						itemData.change = this.onChoiceHigh
					}
					//自定义表头
					if (type === 'professionId') {
						itemData.headerSlot = true
					}
				})
				console.log('this.optionEmployee----', this.optionEmployee)
				//处理带入的数据！！！！！
				if (this.actType === 'new') {
					//处理是否默认加人
					this.onAddEmp()
				}
			} catch (e) {
				this.isCategoryError = `${e.message}，请手动刷新浏览器再次获取工种数据！`
				this.$alert(this.isCategoryError, '提示').then(() => {})
			} finally {
				this.employeeLoading = false
			}
		},
		//通过顶级 和 最后一级 获取三级数据！！！！
		onGetAllProfessionData(cates) {
			//循环外层
			let rootData = []
			let rootZhong = []
			for (let i = 0; i < cates.length; i++) {
				let {industry = '', parentId, parentCode, type} = cates[i]
				if (rootData.findIndex((item) => item.categoryName === industry) === -1) {
					rootData.push({categoryName: industry, categoryCode: i, id: parentId, children: []})
				}
				//循环内层，查找是否存在
				let tempZhongIndex = rootZhong.findIndex((item) => item.categoryName === type)
				if (tempZhongIndex === -1) {
					//不存在
					rootZhong.push({
						categoryName: type,
						categoryCode: parentCode,
						id: parentId,
						categoryNameP: industry,
						children: [cates[i]],
					})
				} else {
					//存在,则直接child 添加
					rootZhong[tempZhongIndex].children.push(cates[i])
				}
			}
			rootData.forEach((itemRoot) => {
				let {categoryName = '', children = []} = itemRoot
				for (let rootZhongElement of rootZhong) {
					if (categoryName === rootZhongElement.categoryNameP) {
						children.push(rootZhongElement)
					}
				}
			})
			return rootData
		},
		//合并历史工种
		onMergeHistoryProfession() {
			//合并历史记录
			if (this.professionHistoryList.length > 0) {
				for (let hisItem of this.professionHistoryList) {
					//解构
					let {parentCode = '', categoryName = '', type = '', categoryCode: categoryCodeHis} = hisItem
					//改名字
					hisItem.categoryName = `${categoryName}（批增工种）`
					let isAdd = false
					this.professionAllData.forEach(({children: childrenWai = []}, waiIndex) => {
						childrenWai.forEach(({children: childrenNei = []}) => {
							let tempIndex = childrenNei.findIndex(({categoryCode: categoryCodeNew = ''}) => {
								//处理泰康和电梯工种变化
								if (isAnZeProduct(this.insureType)) {
									if (categoryCodeHis.charAt(0) !== 'A') {
										categoryCodeHis = categoryCodeHis.replace('0', 'A')
									}
									if (categoryCodeNew.charAt(0) !== 'A') {
										categoryCodeNew = categoryCodeNew.replace('0', 'A')
									}
								}
								return categoryCodeNew === categoryCodeHis || categoryCodeNew === `0${categoryCodeHis}`
							})
							if (tempIndex !== -1) {
								console.log('删除新工种里的数据-----', childrenNei[tempIndex])
								let {highOptions = []} = childrenNei[tempIndex]
								//处理涉高！
								if (highOptions.length > 0) {
									hisItem.highOption = highOptions
								}
								childrenNei.splice(tempIndex, 1)
								childrenNei.push(hisItem)
								isAdd = true
							}
						})
					})
					//如果没加进去，则需要创建节点
					if (!isAdd) {
						//查找第一个存在的数据
						let tempData =
							this.professionAllData.find(
								(itemDataWai = {}) => itemDataWai.children && itemDataWai.children.length > 0,
							) || null
						if (tempData) {
							tempData.children.push({
								categoryName: type,
								categoryCode: parentCode,
								children: [this.deepClone(hisItem)],
							})
						}
					}
				}
			}
		},
		//获取的职业列表 进行等级处理
		onDealProfessionLevel() {
			this.professionAllData.forEach((itemWai = {}) => {
				let {children = []} = itemWai
				children.forEach((itemNei = {}) => {
					let {children: childrenNei = []} = itemNei
					childrenNei.forEach((itemNeiNei = {}) => {
						let {categoryName = '', professionLevel = '', id, categoryCode, scope} = itemNeiNei
						if (categoryName) {
							itemNeiNei.categoryName = `${categoryName} - ${professionLevel}类`
						}
						//存储当前保单数据
						if (id) {
							this.currentProfessionMap.set(id, itemNeiNei)
						}
						if (this.professionAllData.length === 1 && children.length === 1 && childrenNei.length === 1) {
							this.singleCategoryId = id
							//设置数据
							this.onSetEmployeeProfession()
						}
					})
				})
			})
		},
		//去除空数据！！
		onDelEmptyProfession() {
			this.professionAllData = this.professionAllData.filter((itemWai = {}) => {
				let {children = []} = itemWai
				itemWai.children = children.filter((itemNei = {}) => {
					let {children: childrenNei = []} = itemNei
					return childrenNei.length > 0
				})
				return itemWai.children.length > 0
			})
		},
		//增加人 isInit初始化加人
		onAddEmp(isInit = true) {
			//弹窗
			this.onShowLoading()
			let currentLength = this.dataEmployeeList.length
			if (isInit) {
				let tempNum = this.getMinEmpNum - currentLength
				if (tempNum > 0) {
					for (let i = 0; i < tempNum; i++) {
						this.onGetOneEmpData()
					}
				}
			} else {
				if (currentLength >= this.getMaxEmpNum) {
					this.$alert(`最多可投${this.getMaxEmpNum}人，请联系管理员！`, '提示')
						.then(() => {})
						.catch(() => {})
					return
				}
				//点击增加人
				this.onGetOneEmpData()
			}
			//初始化分页
			this.empPage.total = this.dataEmployeeList.length
		},
		//删除人
		onDelEmp(index) {
			//弹窗
			this.onShowLoading()
			console.log(index, '----')
			let {currentPage, pageSize, total} = this.empPage
			this.dataEmployeeList.splice((currentPage - 1) * pageSize + index, 1)
			if (this.dataEmployeeList.length < this.getMinEmpNum) {
				this.$message.error(`该产品最低投保人数为${this.getMinEmpNum}人！`)
			} else {
				setTimeout(() => {
					this.onNeedToCalc()
				}, 200)
			}
		},
		//通过传递的对象生成数据
		onGetOneEmpData() {
			let tempData = {
				sn: getPageId(),
			}
			for (let professionItem in this.empFormAllData) {
				let {type = '', visible = -1, key = ''} = this.empFormAllData[professionItem] || {}
				if (type !== '' && visible === 1) {
					tempData[professionItem] = ''
				}
			}
			tempData.premium = 0
			if (this.singleCategoryId) {
				tempData.professionId = this.singleCategoryId
			}
			tempData.$cellEdit = true
			//加入
			this.dataEmployeeList.push(tempData)
		},
		//处理分页数据！！！
		onDealOnePageData() {
			let {currentPage, pageSize, total} = this.empPage
			if (this.dataEmployeeList.length <= pageSize) {
				this.dataEmployeeItem = this.dataEmployeeList
			} else {
				this.dataEmployeeItem = this.dataEmployeeList.slice(
					(currentPage - 1) * pageSize,
					(currentPage - 1) * pageSize + pageSize,
				)
			}
		},
		onCurrentRowChange(currentRow, oldCurrentRow) {
			console.error(currentRow, oldCurrentRow)
			//修改数据，则需要重新计算保费
			this.$emit('onNeedCalcPrice', false)
		},
		onCellClick() {
			console.error('onCellClick')
			//修改数据，则需要重新计算保费
			this.$emit('onNeedCalcPrice', false)
		},
		//确定人员
		async onSubmitEmployee() {
			if (this.isCategoryError !== '') {
				this.$alert(this.isCategoryError, '提示').then(() => {})
				return
			}
			//判断提交人数够不够
			if (this.dataEmployeeList.length < this.getMinEmpNum) {
				this.$message.error(`该产品最低投保人数为${this.getMinEmpNum}人`)
				return
			}
			if (this.dataEmployeeList.length > this.getMaxEmpNum) {
				this.$message.error(`该产品最多投保人数为${this.getMaxEmpNum}人`)
				return
			}
			//确认其他信息有么有填写完成
			if (!this.onConfirmAllData(false)) {
				return
			}
			this.employeeLoading = true
			//先校验整理不合理的数据
			this.onDealEmpData(this.dataEmployeeList)
			//校验有没有重复错误数据
			if (await this.onGetErrorMsg()) {
				//如果当前一页能展示完，则只需要直接校验！！！
				let {pageSize, total} = this.empPage
				if (pageSize >= total) {
					this.$refs.refEmp.$refs.cellForm
						.validate()
						.then((valid, done, msg) => {
							if (valid) {
								//可以提交！！
								this.onCheckAddHighKey()
							} else {
								this.employeeLoading = false
								this.$message.error('投保人员信息有误，请根据提示信息修改后再确认！')
							}
						})
						.catch(() => {
							this.employeeLoading = false
						})
						.finally(() => {})
				} else {
					//无错误！！
					//可以提交！！
					this.onCheckAddHighKey()
				}
			} else {
				this.employeeLoading = false
			}
		},
		//批增确认需要判断涉高问题，是否有不一致情况
		onCheckAddHighKey() {
			if (!this.isAdd || !this.highKey) {
				this.onCheckEmpResult(true)
				return
			}
			//批增，有涉高
			let tempHint = ''
			for (let i = 0; i < this.dataEmployeeList.length; i++) {
				let {professionId = ''} = this.dataEmployeeList[i]
				let tempHigh = this.dataEmployeeList[i][this.highKey]
				professionId = `${professionId}`
				if (this.oldEmpList.has(professionId)) {
					let {categoryName = ''} = this.oldEmpList.get(professionId)
					let tempHighKey = this.oldEmpList.get(professionId)[this.highKey]
					if (tempHighKey !== tempHigh) {
						//和原保单选择的涉高不一致，则需要提示
						tempHint += `原保单工种【${categoryName}】为【${tempHighKey === '1' ? '涉高' : '不涉高'}】，`
					}
				}
			}
			if (!tempHint) {
				this.onCheckEmpResult(true)
				return
			}
			this.$confirm(`${tempHint}请再次确认保障人员是否涉高！`, '提示', {
				confirmButtonText: '确定无误',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					this.onCheckEmpResult(true)
				})
				.catch(() => {
					this.employeeLoading = false
				})
		},
		//数据没问题，确认成功 type = true 成功
		onCheckEmpResult(type) {
			this.employeeLoading = true
			//相同则不处理
			if (this.isEmployeeSubmit === type) {
				this.employeeLoading = false
				return
			}
			//成功
			//发送计算保费
			if (type) {
				//获取险种最里面的数据
				this.onGetEmpProfessionData()
				this.$emit('onSubmittedData', {type: 5})
			}
			//通过
			this.isCancelNoPrice = type
			this.isEmployeeSubmit = type
			//处理表格头部和menu
			this.onDealMaxOne(!type)
			this.dataEmployeeList.forEach((itemData) => {
				itemData.$cellEdit = !type
			})
			setTimeout(() => {
				this.employeeLoading = false
				if (type) {
					//判断是否工种校验弹窗
					this.onShowInsureNotices()
				}
			}, 500)
		},
		//获取工种item数据
		onGetEmpProfessionData() {
			if (!this.professionKey) {
				return
			}
			//通过工种，获取工种的所有数据
			this.dataEmployeeList.forEach((itemData) => {
				let {professionId = '', professionName = ''} = itemData
				if (professionId) {
					//获取数据
					this.onSaveEmpProfessionData(professionId)
					let {categoryCode, categoryName, scope} = this.choiceProfessionData.get(professionId) || {}
					if (professionName === '' || professionName !== categoryName) {
						itemData.professionCode = categoryCode
						itemData.professionName = categoryName
						itemData.empRole = scope
					}
				}
			})
		},
		//去除空格，以及大小写配置
		onDealEmpData(empList) {
			//循环直接去除非必要的数据
			empList.forEach((itemData) => {
				//这边直接赋值
				if (this.isMore) {
					let {name = '', certNo = '', empName = '', empIdNo = '', certType = ''} = itemData
					if (!certType) {
						itemData.certType = '100'
						itemData.type = '0'
					}
					if (this.isSameEmp) {
						if (name && name !== empName) {
							itemData.empName = name
						}
						if (certNo && certNo !== empIdNo) {
							itemData.empIdNo = certNo
						}
					}
				}
				//循环对象itemData，处理数据
				for (let itemDataKey in itemData) {
					//如果存在
					let values = itemData[itemDataKey] || ''
					if (['name', 'certNo', 'empName', 'empIdNo'].includes(itemDataKey) && !this.validatenull(values)) {
						if (values.includes(' ') && !values.includes(':')) {
							//去除空格
							itemData[itemDataKey] = values.replace(/\s+/g, '')
						}
						if (values.includes('x')) {
							//大写
							itemData[itemDataKey] = values.toUpperCase()
						}
					}
					//处理涉高
					if (this.highKey === 'workType' && itemData[this.highKey]) {
						itemData.feeRate = itemData[this.highKey]
					}
				}
			})
		},
		//循环查错误信息
		async onGetErrorMsg() {
			let emptyData = ''
			let errorData = ''
			let errorNameData = ''
			let errorAgeData = ''
			let sameIdNo = ''
			let sameIdNoMap = new Map()
			let errorHighData = ''
			let checkNoResult = ''
			//需要校验身份证信息！
			let needCheckList = []
			//年龄校验规则
			let nameRegValue = this.getVerifiesName
			let {minAge, maxAge} = this.getVerifiesIdNo

			for (let i = 0; i < this.dataEmployeeList.length; i++) {
				let tempIndex = i + 1
				let tempHang = `【第${tempIndex}行】`
				let empItemData = this.dataEmployeeList[i] || {}
				let {name = '', certNo = '', empName = '', empIdNo = '', professionId = ''} = empItemData
				//判断所有数据都填写完成
				if (!this.onGetOneEmpDataIsOver(empItemData)) {
					emptyData += tempHang
				}
				//批量录入，则校验被保险人信息
				if (this.isMore && !checkData(name, certNo)) {
					let tempIndex = this.checkYesResult.findIndex(({name1, idno1}) => name1 === name && idno1 === certNo)
					if (tempIndex === -1) {
						needCheckList.push({name, idno: certNo})
					}
				}
				if ((!this.isMore || (!this.isSameEmp && empIdNo !== certNo)) && !checkData(empName, empIdNo)) {
					//批量录入，或者同被保险人不一样
					let tempIndex = this.checkYesResult.findIndex(({name1, idno1}) => name1 === empName && idno1 === empIdNo)
					if (tempIndex === -1) {
						needCheckList.push({name: empName, idno: empIdNo})
					}
				}
				//判断涉高是否选错
				if (this.highKey !== '') {
					//是否有涉高
					this.onSaveEmpProfessionData(professionId)
					let {highOptions = []} = this.choiceProfessionData.get(professionId) || {}
					//涉高数据
					let tempHighData = this.dataEmployeeList[i][this.highKey]
					if (highOptions.length === 1) {
						if (highOptions[0] === 0 && tempHighData === '1') {
							errorHighData += tempHang
						}
						if (highOptions[0] === 1 && tempHighData === '2') {
							errorHighData += tempHang
						}
					}
				}

				/**
				 * 校验姓名和身份证数据
				 */
				function checkData(empNameTemp = '', empIdNoTemp = '') {
					let isError = false
					if (!empNameTemp && !empIdNoTemp) {
						return true
					}
					if (!empNameTemp || !empIdNoTemp) {
						isError = true
					}
					if (empNameTemp && nameRegValue) {
						//姓名初步校验
						if (!new RegExp(nameRegValue).test(empNameTemp)) {
							errorNameData += tempHang
							isError = true
						}
					}
					if (empIdNoTemp) {
						//姓名和身份证都填写了
						//身份证初步校验
						if (!isIdCardNoValid(empIdNoTemp)) {
							errorData += tempHang
							isError = true
						} else {
							//先判断身份有没有重复
							if (empIdNoTemp && sameIdNoMap.has(empIdNoTemp)) {
								let index = sameIdNoMap.get(empIdNoTemp)
								sameIdNo += `${sameIdNo ? '，' : ''}${tempHang}和【第${index}行】`
								isError = true
							} else {
								sameIdNoMap.set(empIdNoTemp, tempIndex)
							}
							//继续监测年龄限制
							//判断年龄
							if (maxAge > 0 || minAge > 0) {
								//通过身份证获取年龄
								let tempAge = getAgeByCardNo(empIdNo)
								console.log(empIdNo, '------tempAge', tempAge)
								if (tempAge < minAge || tempAge > maxAge) {
									//有错误
									errorAgeData += tempHang
									isError = true
								}
							}
						}
					}
					return isError
				}
			}
			if (needCheckList.length > 0) {
				//二要素校验
				//确定的时候校验身份证
				let respData = (await checkIdNo(needCheckList).catch(() => {})) || {}
				//处理校验数据
				let {data = [], code = -1} = respData.data || {}
				if (code === 0 && data.length > 0) {
					for (let checkIdNoItem of data) {
						let {name = '', idno = '', result = 0} = checkIdNoItem || {}
						if (!name && !idno) {
							continue
						}
						if (result === 1) {
							checkNoResult += `【姓名：${name}，身份证：${idno}】 <br/>`
						} else {
							//成功校验过的
							this.checkYesResult.push({name1: name, idno1: idno})
						}
					}
				}
			}

			let tempHint = ''
			if (emptyData) {
				tempHint += `${emptyData}数据为空！<br/>`
			}
			if (errorData) {
				tempHint += `${errorData}身份证号不正确！<br/>`
			}
			if (errorNameData) {
				tempHint += `${errorNameData}姓名不正确！<br/>`
			}
			if (errorAgeData) {
				tempHint += `${errorAgeData}年龄不在投保范围内，可投保年龄最小为${minAge}岁，最大为${maxAge}岁！<br/>`
			}
			if (sameIdNo) {
				tempHint += `${sameIdNo}身份证号相同！<br/>`
			}
			if (errorHighData) {
				tempHint += `${errorHighData}是否涉高选择不正确！<br/>`
			}
			if (checkNoResult && this.userInfo.phone !== '18752004865') {
				//韦锋账号不校验
				tempHint += `${checkNoResult} 数据校验不通过，请仔细核对身份证信息！！<br/>`
			}
			if (tempHint !== '') {
				this.$alert(tempHint, '提示', {
					confirmButtonText: '知道了',
					dangerouslyUseHTMLString: true,
				}).then(() => {})
				return false
			}
			return true
		},
		//没有任何问题，处理数据！！
		//@ApiModelProperty("是否允许缺失人员信息报价（1=是；2=否）")
		//private Integer deficiencyOfferFlag = 1;
		onGetSubEmployeeData() {
			this.onDealEmpData(this.dataEmployeeList)
			if (this.dataEmployeeList.length <= 0) {
				return []
			}
			let tempData = this.deepClone(this.dataEmployeeList)
			//是否可以只选工种就能计算保费
			let {deficiencyOfferFlag = 2} = this.getFormConfig
			let tempEmpList = []
			tempData.forEach((itemData) => {
				let {professionId = '', empName = '', empIdNo} = itemData
				if (!this.isMore) {
					//非批量逻辑
					if (!this.professionKey || !this.validatenull(professionId)) {
						if (deficiencyOfferFlag === 1 || (empName !== '' && empIdNo !== '')) {
							//判断涉高是否选了
							if (this.highKey === '' || !this.validatenull(itemData[this.highKey])) {
								tempEmpList.push(itemData)
							}
						}
					}
				} else {
					//批量逻辑
					if (this.onGetOneEmpDataIsOver(itemData)) {
						tempEmpList.push(itemData)
					}
				}
			})
			if (tempEmpList.length < this.getMinEmpNum) {
				return []
			}
			if (tempEmpList.length > this.getMaxEmpNum) {
				this.$message.error(`该产品最多投保人数为${this.getMaxEmpNum}人`)
				return []
			}
			//去除空数据
			tempEmpList.forEach((itemData) => {
				clearEmptyData(itemData)
			})
			console.log('submitDataList--------', tempEmpList)
			return tempEmpList
		},
		//获取批量报价数据
		onGetSubEmployeeMoreData() {
			let empList = this.onGetSubEmployeeData()
			return empList.map((itemData) => {
				let {sn, name, certNo, areaCode, addr, legalPersonMobile, ...empInfo} = itemData
				return {
					sn,
					applicant: {
						name,
						certNo,
						legalPersonMobile,
						areaCode,
						addr,
						type: '0',
						certType: '100',
					},
					empInfos: [
						{
							sn,
							...empInfo,
						},
					],
				}
			})
		},
		//获取所有的数据，包含没有填写完成的,暂存使用
		onGetAllEmployeeData() {
			this.onDealEmpData(this.dataEmployeeList)
			if (this.dataEmployeeList.length <= 0) {
				return []
			}
			return this.deepClone(this.dataEmployeeList)
		},
		//通过ID获取全部数据
		onSaveEmpProfessionData(professionId = '', professionName = '') {
			if (!this.professionKey) {
				return
			}
			if (professionId && !this.choiceProfessionData.has(professionId)) {
				for (let i = 0; i < this.professionAllData.length; i++) {
					let {children = []} = this.professionAllData[i]
					if (children.length > 0) {
						for (let j = 0; j < children.length; j++) {
							let {children: childrenWai = []} = children[j]
							for (let k = 0; k < childrenWai.length; k++) {
								let itemNeiData = childrenWai[k] || {}
								let {id = '', categoryCode = '', categoryName = ''} = itemNeiData
								//先保存
								if (id === professionId && (!professionName || categoryName.includes(professionName))) {
									this.choiceProfessionData.set(professionId, itemNeiData)
								} else {
									//传递的是code，不是ID，再次保存
									if (categoryCode === professionId && (!professionName || categoryName.includes(professionName))) {
										this.choiceProfessionData.set(id, itemNeiData)
										this.choiceProfessionData.set(categoryCode, itemNeiData)
									}
								}
							}
						}
					}
				}
				console.log(this.choiceProfessionData, '---1')
			}
		},
		//选择工种
		onChoiceProfession(professionData) {
			let {column = {}, value = '', index} = professionData
			//弹窗
			this.onShowLoading()
			if (value !== '' && this.isCancelNoPrice) {
				console.log('onChoiceProfession ------', column, value, professionData)
				let {categoryCode = ''} = this.currentProfessionMap.get(value) || {}
				let {prop = ''} = column
				let isCalc = true
				//复制工种
				//选择工种之后，如果还有空工种，则不需要计算保费
				this.dataEmployeeList.forEach((itemData) => {
					if (this.validatenull(itemData[prop]) || itemData[prop] == value) {
						//复制工种
						itemData[prop] = value
						itemData.professionCode = categoryCode
					}
				})
				this.isContinueProfessionId = ''
				//判断是否工种校验弹窗
				this.onShowInsureNotices(value)
				//是否有涉高
				this.onDelHigh()
				if (isCalc) {
					//修改数据，则需要重新计算保费
					this.onNeedToCalc()
				}
			}
			this.isCancelNoPrice = true
		},
		onChoiceHigh(highData) {
			console.log('onChoiceHigh------', highData)
			let {
				value = '',
				row: {professionId = ''},
				column: {prop = ''} = {},
			} = highData || {row: {}}
			//处理一下其他数据
			if (professionId) {
				this.dataEmployeeList.forEach((itemData) => {
					let {professionId: professionId1} = itemData
					if (professionId1 === professionId && !itemData[this.highKey] && !itemData['hasSocial']) {
						itemData[prop] = value
					}
				})
			}
			//是否需要计算保费，如果包含则需要计算保费
			if (this.needCalcPriceList.has(prop)) {
				this.onNeedToCalc()
			}
		},
		//设置投保人员！！
		onSetEmployeeData(empDataList = []) {
			//判断人数是否大于最大值，如果是的，则去除
			if (this.getMaxEmpNum > 0 && this.getMaxEmpNum < empDataList.length) {
				empDataList = empDataList.slice(0, this.getMaxEmpNum)
			}
			if (empDataList.length > 0) {
				//最后一个参数 是否要删除remark，美的光伏的不删，新投保需要删除
				this.dataEmployeeList = getTransEmpData(empDataList, this.isMore, !isBxMeidiGuangfu())
				//是否有涉高
				this.onDelHigh()
			}
			//如果不满最低投保人员，还要再加
			this.onAddEmp()
			//设置工种
			this.onSetEmployeeProfession()
			// this.$refs.refEmp.refreshTable()
		},
		//清除工种信息
		onClearEmpData() {
			this.dataEmployeeList.forEach((itemData) => {
				itemData.professionId = ''
				itemData.professionCode = ''
				itemData.professionName = ''
			})
			this.onCheckEmpResult(false)
		},
		//设置投保人员金额
		onEmpSetPriceData(targetItems, planData = {}) {
			//不能直接计算 会报错！！
			let tempEmpList = this.deepClone(this.dataEmployeeList)
			tempEmpList.forEach((itemData) => {
				let {sn = '', empIdNo = '', certNo = ''} = itemData
				//查找数据
				let tempData = targetItems.find(
					({sn: snNei = '', empIdNo: empIdNoNei = '', certNo: certNoNei = ''}) =>
						sn === snNei && empIdNo === empIdNoNei && certNo === certNoNei,
				)
				if (!this.validatenull(tempData)) {
					let {premium, priceId, sourcePriceId} = tempData
					itemData.premium = premium
					itemData.price = parseInt((premium * 100).toFixed(0))
					itemData.priceId = priceId
					itemData.sourcePriceId = sourcePriceId
					itemData.newPriceId = priceId
				} else {
					itemData.price = 0
					itemData.premium = 0
				}
				itemData.amount = planData.amount || ''
			})
			this.dataEmployeeList = tempEmpList
		},
		//  下载批量导入模板
		handleGetEmployeeTemplate() {
			this.isDownLoading = true
			let fileName = `${this.productId}_template_chinalife_${currentYYYYmmdd()}.xlsx`
			//不同模板
			let tempUrl = ''
			if (!this.isMore) {
				let sameUrl = !this.validatenull(this.orderId)
					? `categoryDownload/${this.orderId}`
					: `categoryDownloadPid/${this.sourceProductId}`
				tempUrl = `/dist/distInsure/${sameUrl}`
			} else {
				tempUrl = `/dist/bowei/file?path=/index/category/batch/download_pid/${this.sourceProductId}`
			}
			handleDownCategoryFile(tempUrl, {}, fileName)
				.then(() => {
					//下载成功
					this.$message.success('工种模板下载成功！')
				})
				.catch(() => {})
				.finally(() => {
					this.isDownLoading = false
				})
		},
		// 批量导入!!
		handleEmployeeFileChange(file) {
			let tempEmpList = []
			this.employeeLoading = true
			setTimeout(() => {
				this.$Export
					.xlsx(file.raw)
					.then(async (result) => {
						// //先循环去除空数据
						// this.dataEmployeeList = this.dataEmployeeList.filter(({empName = '',empIdNo = ''}) => {
						//   return empName && empIdNo
						// })
						console.log('批量导入文件内容----', result)
						let {results = []} = result || {}
						if (results.length <= 0) {
							this.$message.error('批量导入文件数据为空！')
							this.employeeLoading = false
							return
						}
						//记录出错工种的序号
						let isErrorProfessionList = []
						let isErrorCodeList = []
						for (let i = 0; i < results.length; i++) {
							let tempEmp = {
								empName: '',
								empIdNo: '',
								professionId: '',
							}
							let tempItemData = Object.values(results[i]) || []
							if (tempItemData.length >= 3) {
								//解构 数据，one,two 15个字段
								let [zero, one, two, three, four, five, six, seven, eight, nine, ten, eleven, twelve] = tempItemData
								if (zero && (zero !== '序号' || typeof zero == 'number') && one && two) {
									if (!this.isMore) {
										//不是批量
										tempEmp.empName = `${one}` || ''
										tempEmp.empIdNo = `${two}` || ''
										//处理第七个字段，涉高
										//处理涉高
										if (seven && seven.includes('涉高')) {
											this.$set(tempEmp, this.highKey, seven === '涉高' ? '1' : '2')
										}
									} else {
										//批量
										tempEmp.certType = '100'
										tempEmp.type = '0'
										tempEmp.same = '1'
										tempEmp.name = `${one}` || ''
										tempEmp.certNo = `${three}` || ''
										tempEmp.legalPersonMobile = `${two}` || ''
										//地区
										if (six && six.includes('-')) {
											let tempArea = six.split('-')[1] || ''
											//先获取地区
											await setAreaList()
											//校验地区的值对不对
											//在检查code是否存在
											let isArea = isAreaExist(tempArea, 3)
											if (isArea) {
												tempEmp.areaCode = tempArea
											} else {
												//报错
												isErrorCodeList.push(tempArea)
											}
										}
										tempEmp.addr = seven || ''
										//忽略被保人
										// tempEmp.empName = eight || ''
										// tempEmp.empIdNo = nine || ''
									}
									//处理工种数据！，区分批量
									let tempProfessionData = !this.isMore ? five : ten
									if (this.professionKey && tempProfessionData && tempProfessionData.includes('-')) {
										let [tempName = '', tempCode = ''] = tempProfessionData.split('-')
										if (tempName && tempCode) {
											//获取全部数据
											this.onSaveEmpProfessionData(tempCode, tempName)
											if (this.choiceProfessionData.has(tempCode)) {
												//填充数据
												let {
													id = '',
													categoryCode = '',
													categoryName = '',
													scope = '',
												} = this.choiceProfessionData.get(tempCode) || {}
												//判断工种名字是不是一致
												if (categoryName.includes(tempName)) {
													tempEmp.professionId = id
													tempEmp.professionCode = categoryCode
													tempEmp.professionName = categoryName
													tempEmp.empRole = scope
												} else {
													isErrorProfessionList.push(tempProfessionData)
												}
											}
										}
									}
									tempEmpList.push(Object.assign(tempEmp, {sn: getPageId(), premium: 0, $cellEdit: true}))
								}
							}
						}
						//去除检查数据
						this.onDealEmpData(tempEmpList)
						//还得去除有问题的
						tempEmpList = tempEmpList.concat(this.dataEmployeeList).filter(({empName = '', empIdNo = ''}) => {
							return empName && empIdNo
						})
						console.log(tempEmpList, '------')
						this.employeeLoading = false
						if (tempEmpList.length <= 0) {
							this.$alert('批量导入文件数据为空，请检查文件！').then(() => {})
							return
						}

						let tempHint = ''
						if (isErrorCodeList.length > 0) {
							tempHint += `地区数据有误：${isErrorCodeList.join('，')}\n`
						}
						if (isErrorProfessionList.length > 0) {
							tempHint += `工种数据有误：${isErrorProfessionList.join('，')}\n`
						}
						//是否报错，如果报错，则弹窗
						if (tempHint) {
							this.$alert(tempHint, '警告', {
								dangerouslyUseHTMLString: true,
								confirmButtonText: '我知道了',
							}).then(() => {})
						}

						this.dataEmployeeList = this.deepClone(tempEmpList)
						//是否有涉高
						this.onDelHigh()
						//清空标识
						this.isContinueProfessionId = ''
						//判断是否工种校验弹窗
						this.onShowInsureNotices()
						//检查对错 没问题触发计算保费
						if (await this.onGetErrorMsg()) {
							//发送一次结算保费
							this.onNeedToCalc()
						}
					})
					.catch((error) => {
						console.log('批量导入文件错误----', error)
						this.$alert(error.message || '批量导入文件错误！').then(() => {})
						this.employeeLoading = false
					})
					.finally(() => {
						this.employeeLoading = false
					})
			}, 800)
		},
		//一键清空
		onClearAllData() {
			if (this.dataEmployeeList.length <= 0) {
				this.$message.error('保障人员信息为空！')
				return
			}
			this.$confirm('是否确认删除所有的保障人员信息？', '警告', {
				confirmButtonText: '确认清空',
				cancelButtonText: '取消',
			}).then(() => {
				this.dataEmployeeList = []
				this.$emit('onClearAllData')
			})
		},
		//确认信息获取option
		onGetEmpOption() {
			return this.deepClone(this.optionEmployee)
		},
		//是否确定
		isConfirm() {
			return !this.isEmployeeSubmit
		},
		//loading
		onShowLoading() {
			this.employeeLoading = true
			setTimeout(
				() => {
					this.employeeLoading = false
				},
				this.isMore ? 1000 : 500,
			)
		},
		//是否只选工种就能计算保费？
		//@ApiModelProperty("是否允许缺失人员信息报价（1=是；2=否）")
		//private Integer deficiencyOfferFlag = 1;
		onNeedToCalc() {
			let isMust = false
			let {deficiencyOfferFlag = 2} = this.getFormConfig
			let tempIndex = this.dataEmployeeList.findIndex(({professionId = '', empName = '', empIdNo = ''}) => {
				return professionId === '' || (deficiencyOfferFlag === 2 && (empName === '' || empIdNo === ''))
			})
			if (tempIndex === -1) {
				isMust = true
			}
			//修改数据，则需要重新计算保费
			this.$emit('onNeedCalcPrice', isMust)
		},
		onDelRepeat(emps) {
			//删除重复投保
			let tempEmployeeList = this.dataEmployeeList.filter(({empIdNo}) => {
				return emps.findIndex((itemData) => itemData.empIdNo === empIdNo) === -1
			})
			this.dataEmployeeList = this.deepClone(tempEmployeeList)
			return tempEmployeeList
		},
		//处理涉高！！
		onDelHigh() {
			if (this.highKey !== '') {
				this.dataEmployeeList.forEach((itemData) => {
					let {professionId = ''} = itemData
					//是否有涉高
					if (professionId !== '') {
						professionId = `${professionId}`
						if (this.isAdd && this.oldEmpList.has(professionId)) {
							//如果为批增，并且原保单列表有数据，则需要默认填充
							itemData[this.highKey] = this.oldEmpList.get(professionId)[this.highKey]
						} else {
							this.onSaveEmpProfessionData(professionId)
							let {highOptions = []} = this.choiceProfessionData.get(professionId) || {}
							//涉高数据
							if (highOptions.length === 1) {
								itemData[this.highKey] = highOptions[0] === 0 ? '2' : '1'
							}
						}
					}
				})
			}
		},
		//判断每个人员信息是否填写完成
		onGetOneEmpDataIsOver(itemData = {}) {
			let isOver = true
			for (let empItemDataKey in this.empFormAllData) {
				//判断是否必填 1：必填 2：非必填
				let {required = 0} = this.empFormAllData[empItemDataKey]
				if (empItemDataKey !== 'config' && required === 1) {
					if (this.validatenull(itemData[empItemDataKey])) {
						console.error(`当前数据为空----empItemData------${empItemDataKey}:${itemData[empItemDataKey]},`)
						isOver = false
						break
					}
				}
			}
			return isOver
		},
		//判断是否有涉高
		onHasHigh(newVal) {
			for (let newValKey in newVal) {
				let {type = '', label = '', key, visible = -1, required = -1, refresh = 0} = newVal[newValKey]
				if (visible === 1 && required === 1) {
					if (key === 'workType') {
						this.highKey = key
					} else if (newValKey === 'professionId') {
						this.professionKey = key
					}
				}
				if (refresh === 1) {
					this.needCalcPriceList.set(key, true)
				}
			}
		},
		//身份证识别成功
		async onCardSuccess(cardResult) {
			for (let cardResultElement of cardResult) {
				let {name = '', idno = '', address = ''} = cardResultElement
				//先判断身份证是否存在
				let tempIndex = this.dataEmployeeList.findIndex(({empIdNo, certNo = ''}) => empIdNo === idno || certNo === idno)
				if (tempIndex === -1) {
					//不存在直接添加
					let tempData = this.dataEmployeeList.find(({empName, empIdNo, name: name1, certNo}) => {
						if (!this.isMore) {
							return empName === '' && empIdNo === ''
						} else {
							return name1 === '' && certNo === ''
						}
					})
					if (!tempData) {
						//没有找到，则加数据
						this.onAddEmp(false)
						//再次复制
						tempData = this.dataEmployeeList[this.dataEmployeeList.length - 1]
					}
					tempData.empName = name
					tempData.empIdNo = idno
					if (this.isMore) {
						tempData.name = name
						tempData.certNo = idno
						//地区
						tempData.addr = address
						//先获取地区
						let tempArea = idno.substring(0, 6)
						await setAreaList()
						//校验地区的值对不对
						//在检查code是否存在
						let isArea = isAreaExist(tempArea, 3)
						tempData.areaCode = isArea ? tempArea : ''
					}
				} else {
					this.$message.error('该身份证信息已存在！')
				}
			}
		},
		//如果最大投保人数为1人，则不需要头部以及menu
		onDealMaxOne(type = true) {
			this.optionEmployee.header = type && this.getMaxEmpNum > 1 && !isBxMeidiGuangfu()
			this.optionEmployee.menu = type && this.getMaxEmpNum > 1
		},
		//个意险接收的身份证信息
		onEmitEmpData(unitData) {
			let {name = '', certNo = ''} = unitData
			if (this.dataEmployeeList.length > 0) {
				Object.assign(this.dataEmployeeList[0], {empName: name, empIdNo: certNo})
			}
		},
		/**
		 * 批量录入：---------代码
		 *
		 */
		//处理被保人员显示隐藏
		onShowBeiEmpData() {
			if (!this.isMore) {
				return
			}
			this.optionEmployee.indexWidth = 50
			this.optionEmployee.menuWidth = 80
			//赋值给工种
			this.optionEmployee.column.forEach((itemData) => {
				let {prop = ''} = itemData
				if (prop === 'name' || prop === 'empName') {
					itemData.minWidth = 100
				}
				if (prop === 'certNo' || prop === 'empIdNo' || prop === 'professionId') {
					itemData.minWidth = 130
				}
				if (prop === 'premium') {
					itemData.minWidth = 80
				}
			})
			this.onHideBeiEmp()
		},
		//隐藏被保人
		onHideBeiEmp() {
			this.optionEmployee.column.forEach((itemData) => {
				let {prop = ''} = itemData
				if (prop === 'empName' || prop === 'empIdNo') {
					itemData.hide = this.isSameEmp
					// itemData.display = this.isSameEmp
				}
			})
		},
		//如果被保人和投保人不同，则复制数据！！
		onNoSameCopyData() {
			this.dataEmployeeList.forEach((itemData) => {
				let {name = '', certNo = '', empName = '', empIdNo = ''} = itemData
				if (name && !empName) {
					itemData.empName = name
				}
				if (certNo && !empIdNo) {
					itemData.empIdNo = certNo
				}
			})
		},
		//获取原保单数据
		getOldEmpList() {
			//获取原保单人员数据，处理涉高数据
			if (this.highKey) {
				fetchEmployeeListPage({orderId: this.orderId, pageNo: 1, pageSize: 300})
					.then((resEmpList) => {
						let {records = []} = resEmpList.data.data || {}
						for (let i = 0; i < records.length; i++) {
							let {professionId, category = {}} = records[i] || {}
							category[this.highKey] = `${records[i][this.highKey]}`
							this.oldEmpList.set(`${professionId}`, category)
						}
					})
					.catch(() => {})
			}
		},
		/**
		 * 只有一个工种时，赋值数据
		 */
		onSetEmployeeProfession() {
			console.log('singleCategoryId-------1>', this.singleCategoryId, this.dataEmployeeList.length)
			if (this.singleCategoryId && this.dataEmployeeList.length > 0) {
				this.dataEmployeeList.forEach((itemData) => {
					//只有一个工种，直接覆盖
					this.$set(itemData, 'professionId', this.singleCategoryId)
				})
			}
			if (isBxMeidiGuangfu()) {
				this.optionEmployee.column.forEach((itemData) => {
					let {prop = ''} = itemData
					if (prop === 'empName' || prop === 'empIdNo') {
						itemData.disabled = true
					}
				})
			}
		},
		/**
		 * 判断是否需要弹窗
		 */
		onShowInsureNotices(tempProfessionId = '') {
			let {options = []} = this.empFormAllData.professionId || {}
			if (options.length <= 0) {
				return
			}
			//循环
			for (let i = 0; i < this.dataEmployeeList.length; i++) {
				let itemData = this.dataEmployeeList[i]
				let {professionId = '', professionCode = ''} = itemData
				if (
					!professionId ||
					!professionCode ||
					(tempProfessionId && tempProfessionId !== professionId) ||
					professionId == this.isContinueProfessionId
				) {
					continue
				}
				let professionItemData = this.currentProfessionMap.get(professionId) || {}
				let {hintFreq = -1} = professionItemData
				if (hintFreq == 1) {
					//如果提示频率为1，则不提示
					continue
				}
				let tempData = options.find(({value = ''}) => value === professionCode)
				//如果不存在，返回
				if (!tempData) {
					continue
				}
				let {hintFreq: tempHintFreq = 0, hintInfo = null} = tempData

				if (hintInfo && tempHintFreq > 0) {
					//存储
					this.currentProfessionMap.set(professionId, {
						...professionItemData,
						hintFreq: tempHintFreq,
					})
					this.isContinueProfessionId = professionId
					this.$refs.refInsureNoticesHint.onShowNotices(hintInfo)
					break
				}
			}
		},
		onConfirmAutoStatus() {
			//继续弹窗
			this.onShowInsureNotices()
		},
		onToCancel() {
			this.onShowInsureNotices()
		},
		/**
		 * 清空工种
		 */
		onClearProfession() {
			//加一个清空工种二次确认
			this.$confirm('是否确认删除工种信息？', '提示', {
				confirmButtonText: '确认删除',
				cancelButtonText: '取消',
			})
				.then(() => {
					this.dataEmployeeList.forEach((itemData) => {
						itemData.professionId = ''
						itemData.professionCode = ''
					})
				})
				.catch(() => {})
		},
	},
}
</script>
<style lang="scss" scoped>
::v-deep .avue-crud__menu {
	justify-content: center;
}

::v-deep .emp_submitted .avue-crud__pagination {
	// display: none;
	//不可点击
	pointer-events: none;
}
</style>
